export const environment = {
  production: true,
  gmapsKey: 'AIzaSyC5D2NkJHmHFgRgG8RP3ZnR7aQl2D-7tT0',
  domain: 'preprod-alwayson.integrix.lu',
  env: 'preprod',
  mobileUrl: 'https://preprod-alwayson.integrix.lu/mobile',
};
